import { render } from "./MaterialIconButton.vue?vue&type=template&id=3e704b7d&scoped=true&lang=pug"
import script from "./MaterialIconButton.vue?vue&type=script&lang=ts"
export * from "./MaterialIconButton.vue?vue&type=script&lang=ts"

import "./MaterialIconButton.vue?vue&type=style&index=0&id=3e704b7d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e704b7d"

export default script